<template>
  <header>
    <div class="header-auto flex flex_align-items flex_space-between">

      <div class="header-auto-logo flex flex_align-items pointer" @click="$router.replace('/home')">
        <img src="../assets/logo.png" alt="">
        <span>BICSP在线学习系统</span>
      </div>

      <div class="header-auto-login">

        <div class="login-desc pointer">
          <div class="head-box flex flex_align-items">
            <!-- 用户头像 -->
            <img class="head-portrait" v-if="!user.photo" src="@/assets/image/aviator.png" alt="">
            <img class="head-portrait" v-else :src="baserUrl + (user && user.photo)" alt="">
            <!-- 用户卡片 -->
            <div class="head-use-card" v-if="isShowCard">
              <div class="card-inner">
                <div class="card-inner-header" >
                  <img class="head-portrait" v-if="!user.photo" src="@/assets/image/aviator.png" alt="">
                  <img class="head-portrait" v-else :src="baserUrl + (user && user.photo)" alt="">
                  <span>{{user.loginName || ''}}</span>
                </div>
                <div class="card-inner-center" >
                  <ul>
                    <router-link to="/homeUser">
                      <li class="items">
                        <i class="el-icon-user-solid"></i>
                        <span>个人设置</span>
                      </li>
                    </router-link>
                    <router-link to="/homeUser">
                      <li class="items">
                        <i class="el-icon-s-management"></i>
                        <span>学习情况</span>
                      </li>
                    </router-link>
                  </ul>
                  <el-button style="width: 100%" type="danger" plain @click="handleLoginOut">安全退出</el-button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>
  </header>
</template>

<script>
export default {
  name: 'appHeader',
  data() {
    return {
      baserUrl: this.$API.BASE_URL,
      user: {},
      isShowCard: false
    }
  },
  props:{
    userInfo: [Object, Array]
  },
  created() {
    this.$get(this.$API.MEMBER_INFO, {}).then(res => {
      if (res.code === 200) {
        this.user = res.data
      }
    })
  },
  mounted() {
    //点击任意位置关闭区域弹窗
    document.addEventListener('click',(e) => {
      if(e.target._prevClass === "head-portrait") {
        if(this.isShowCard) this.isShowCard = false;
        else this.isShowCard = true;
      } else {
        this.isShowCard = false
      }
    })
  },
  methods: {
    handleLoginOut() {
      this.$get(this.$API.MEMBER_LOGOUT).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '退出登录成功',
            type: 'success'
          });
          localStorage.clear()
          setTimeout(() => {
            this.$router.push('/')
          }, 1000)
        } else this.$message.error(res.msg);
      }).catch(err => {
        console.log(err)
      })
    }
  },
  watch: {
    userInfo: {
      deep: true,
      handler(val) {
        this.user = val
      }
    }
  }
}
</script>

<style scoped lang="scss">
header {
  background: #FFFFFF;
  border-bottom: 1px solid #ccc;
}

.header-auto {
  height: 80px;
  margin: 0 auto;
  width: 1400px;

  &-logo {
    font-size: 28px;
    color: $font-text-color;

    img {
      margin-right: 10px;
      width: 100px;
    }
  }

  &-login {
    height: 100%;

    .login-desc {
      height: 100%;

      position: relative;

      .head-box {
        height: 100%;


      }

      .head-use-card {
        position: absolute;
        right: 0;
        top: 80px;
        z-index: 1000;
        width: 300px;
        padding: 20px;
        background-color: #fff;
        box-shadow: 0 3px 5px 0 rgba(7, 17, 27, 0.2);
        border-bottom-right-radius: 8px;
        border-bottom-left-radius: 8px;
        box-sizing: border-box;

        .card-inner {
          &-header {
            display: flex;
            align-items: flex-start;

            img {
              flex-shrink: 0;
              margin-right: $spacing-row-sm;
            }
          }

          &-center {
            margin-top: $spacing-row-base;

            ul {
              width: 100%;
              margin-bottom: $spacing-row-lg;

              .items {
                margin-bottom: 20px;
                text-align: center;
                background: #F8FAFC;
                padding: $spacing-row-sm 0;
                font-size: $font-size-base;

                span {
                  margin-left: $spacing-cols-sm;
                }
              }
            }
          }
        }
      }

      .head-portrait {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #FFFFFF;

        &:hover {
          border: 1px solid #409EFF;

          .head-use-card {
            display: block;
          }
        }
      }

    }
  }
}
</style>
